<div class="dialog">
    <div class="dialog_content pb-0" mat-dialog-content>
        <img src="./assets/images/icons/success.svg" alt="success image">
        <h2>  {{"companyAdminProfile.Your wallet has been successfully charged"|translate}} </h2>
        <p class="amount">{{data?.amount | number}} <span>{{"companyAdminProfile.point"|translate}}</span></p>
        <p class="balance">{{"companyAdminProfile.Your current balance"|translate}} {{data?.current_balance | number}} {{"companyAdminProfile.point"|translate}}</p>

        <div class="dialog_actions justify-content-center" mat-dialog-actions >
            <button mat-raised-button mat-dialog-close class="btn-primary">{{"swalMsg.Ok"|translate}}</button>
        </div>
    </div>
</div>